import styled from 'styled-components';

const Container = styled.div``;

const Header = styled.div`
  margin-bottom: 2.4rem;

  display: flex;
  justify-content: space-between;
`;

const ButtonsContainer = styled.div`
  display: flex;
  gap: 2rem;
`;

const Tabs = styled.div``;

export { Container, ButtonsContainer, Header, Tabs };
